import { Video } from '../types/video';

export const healthVideos: Video[] = [
  {
    id: '1',
    title: 'Vagus Nerve Exercises',
    description: 'Learn essential vagus nerve stimulation techniques',
    thumbnail: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=800&auto=format&fit=crop',
    url: '/videos/vagus-nerve.mp4',
    duration: '15 min'
  },
  {
    id: '2',
    title: 'Advanced Vagus Nerve Techniques',
    description: 'Deep dive into advanced vagus nerve exercises',
    thumbnail: 'https://images.unsplash.com/photo-1599901860904-17e6ed7083a0?w=800&auto=format&fit=crop',
    url: '/videos/advanced-vagus.mp4',
    duration: '20 min',
    isPremium: true
  },
  {
    id: '3',
    title: 'Daily Vagus Nerve Routine',
    description: 'Incorporate vagus nerve exercises into your daily routine',
    thumbnail: 'https://images.unsplash.com/photo-1518611012118-696072aa579a?w=800&auto=format&fit=crop',
    url: '/videos/daily-vagus.mp4',
    duration: '10 min'
  }
];

export const breathingVideos: Video[] = [
  {
    id: '1',
    title: 'Box Breathing Technique',
    description: 'Learn the powerful box breathing method used by Navy SEALs',
    thumbnail: 'https://images.unsplash.com/photo-1518241353330-0f7941c2d9b5?w=800&auto=format&fit=crop',
    url: '/videos/box-breathing.mp4',
    duration: '5 min'
  },
  {
    id: '2',
    title: '4-7-8 Breathing Exercise',
    description: 'A natural tranquilizer for the nervous system',
    thumbnail: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=800&auto=format&fit=crop',
    url: '/videos/478-breathing.mp4',
    duration: '8 min',
    isPremium: true
  },
  {
    id: '3',
    title: 'Alternate Nostril Breathing',
    description: 'Balance your energy and calm your mind',
    thumbnail: 'https://images.unsplash.com/photo-1499209974431-9dddcece7f88?w=800&auto=format&fit=crop',
    url: '/videos/nostril-breathing.mp4',
    duration: '10 min'
  }
];

export const meditationVideos: Video[] = [
  {
    id: '1',
    title: 'Mindfulness Meditation',
    description: 'Begin your journey to mindfulness with this guided session',
    thumbnail: 'https://images.unsplash.com/photo-1593811167562-9cef47bfc4d7?w=800&auto=format&fit=crop',
    url: '/videos/mindfulness.mp4',
    duration: '15 min'
  },
  {
    id: '2',
    title: 'Loving-Kindness Meditation',
    description: 'Develop compassion for yourself and others',
    thumbnail: 'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=800&auto=format&fit=crop',
    url: '/videos/loving-kindness.mp4',
    duration: '12 min',
    isPremium: true
  },
  {
    id: '3',
    title: 'Body Scan Meditation',
    description: 'Release tension and find deep relaxation',
    thumbnail: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=800&auto=format&fit=crop',
    url: '/videos/body-scan.mp4',
    duration: '20 min'
  }
];

export const stretchVideos: Video[] = [
  {
    id: '1',
    title: 'Morning Stretch Routine',
    description: 'Start your day with gentle stretches to wake up your body',
    thumbnail: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=800&auto=format&fit=crop',
    url: '/videos/morning-stretch.mp4',
    duration: '15 min'
  },
  {
    id: '2',
    title: 'Desk Stretches',
    description: 'Quick stretches to relieve tension from sitting',
    thumbnail: 'https://images.unsplash.com/photo-1599901860904-17e6ed7083a0?w=800&auto=format&fit=crop',
    url: '/videos/desk-stretch.mp4',
    duration: '8 min',
    isPremium: true
  },
  {
    id: '3',
    title: 'Full Body Flexibility',
    description: 'Comprehensive stretching routine for whole body flexibility',
    thumbnail: 'https://images.unsplash.com/photo-1518611012118-696072aa579a?w=800&auto=format&fit=crop',
    url: '/videos/flexibility.mp4',
    duration: '20 min'
  }
];